export const isVueDraggableMoveEvent = (event: DragEvent) => {
  // On Mac when taking a screenshot and immediately dragging the thumbnail into the browser window.
  const moveScreenshotThumbnailOnMacEvent = event?.dataTransfer?.effectAllowed === 'copyMove';

  return !moveScreenshotThumbnailOnMacEvent && event?.dataTransfer?.effectAllowed?.toLowerCase().includes('move');
};
